module.exports = __webpack_public_path__ + "img/_icon-stamps.4c93bf80.svg";